import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import LoginPage from "./pages/Login/LoginPage";
import DashboardPage from "./pages/Dashboard/DashboardPage";
import ModulePage from "./pages/Module/ModulePage";
import PickupQueuePage from "./pages/PickupQueue/PickupQueuePage";
import OrderDetailPage from "./pages/OrderDetail/OrderDetailPage";
import ProductFormPage from "./pages/ProductForm/ProductFormPage";
import OutletProductPage from "./pages/OutletProduct/OutletProductPage";
import ProfilePage from "./pages/Profile/ProfilePage";
import ProtectedRoute from "./components/ProtectedRoute";
import AppLayout from "./components/AppLayout/AppLayout";

const isAuthenticated = () => localStorage.getItem("vendor_token") !== null;

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        <Route
          path="/vendor"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated()}>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="pickup-queue" element={<PickupQueuePage />} />
          <Route path="orders" element={<ModulePage type="orders" />} />
          <Route path="orders/:orderNo" element={<OrderDetailPage />} />
          <Route path="outlet-products" element={<OutletProductPage />} />
          <Route path="products/create" element={<ProductFormPage mode="create" />} />
          <Route path="products/:productId/edit" element={<ProductFormPage mode="edit" />} />
          <Route path="reports" element={<ModulePage type="reports" />} />
          <Route path="settings" element={<ModulePage type="settings" />} />
          <Route path="profile" element={<ProfilePage />} />
        </Route>

        <Route
          path="*"
          element={isAuthenticated() ? <Navigate to="/vendor" /> : <Navigate to="/login" />}
        />
      </Routes>
    </Router>
  );
}

export default App;
